import { useState, useEffect } from "react";
import {
  PublicClientApplication,
  InteractionStatus,
} from "@azure/msal-browser";
import { MsalProvider, useMsal, useIsAuthenticated } from "@azure/msal-react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { msalConfig } from "./shared/auth/msalConfig";
import { RegistryProvider } from "./shared/api/RegistryContext";
import { T } from "./shared/styles/theme";
import LoginScreen from "./components/LoginScreen";
import ShellLayout from "./components/ShellLayout";
import Home from "./pages/Home";
import IframeView from "./pages/IframeView";

const msalInstance = new PublicClientApplication(msalConfig);

function AppContent() {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();

  if (inProgress !== InteractionStatus.None) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: T.bg,
          color: T.muted,
          fontSize: 14,
        }}
      >
        Authenticating...
      </div>
    );
  }

  if (!isAuthenticated) return <LoginScreen />;

  return (
    <RegistryProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<ShellLayout />}>
            <Route index element={<Home />} />
            <Route path="dashboard/*" element={<IframeView />} />
            <Route path="qai" element={<IframeView />} />
            {/* Any other route an admin registers in Portal Admin (any "/..."
                is allowed there). IframeView sends unknown paths home. */}
            <Route path="*" element={<IframeView />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </RegistryProvider>
  );
}

export default function App() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    msalInstance.initialize().then(() => {
      msalInstance
        .handleRedirectPromise()
        .then(() => setReady(true))
        .catch(() => setReady(true));
    });
  }, []);

  if (!ready) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: T.bg,
          color: T.primary,
          fontFamily: "Calibri,'Segoe UI',system-ui,sans-serif",
          fontSize: 18,
        }}
      >
        Loading…
      </div>
    );
  }

  return (
    <MsalProvider instance={msalInstance}>
      <AppContent />
    </MsalProvider>
  );
}
